export default __webpack_public_path__ + "static/media/logoutIcon.b79f5e89.svg";